var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
    name: 'Menú Diario',
    icon: 'ni ni-calendar-grid-58 text-primary'
  }}},[(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Niveles',
      icon: 'ni ni-diamond text-primary',
      path: '/niveles'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Pedidos',
      icon: 'ni ni-bag-17 text-primary',
      path: '/pedidos'
    }}}):_vm._e(),(_vm.hasDarkKitchen && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Supervisor',
      icon: 'ni ni-single-02 text-green'
    }}},[_c('sidebar-item',{attrs:{"link":{
        name: 'Checklist',
        path: '/supervisor/checklist',
        icon: 'ni ni-single-02 text-primary'
      }}})],1):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Pesos Cocidos',
      icon: 'ni ni-ruler-pencil text-success',
      path: '/pesos-cocidos'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Cantidades',
      icon: 'ni ni-bullet-list-67 text-primary',
      path: '/cantidades'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Recetas',
      icon: 'ni ni-collection text-primary',
      path: '/recetas'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Reclamos',
      icon: 'ni ni-book-bookmark text-primary',
      path: '/reclamos'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Feedback',
      icon: 'ni ni-single-02 text-primary',
      path: '/feedback'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Espera del repartidor',
      icon: 'ni ni-watch-time text-primary',
      path: '/espera-del-repartidor'
    }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
      name: 'Entregas',
      icon: 'ni ni-delivery-fast text-warning',
      path: '/delivery'
    }}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }